import { DENY_URLS, IGNORE_ERRORS_LIST, NORMALIZE_DEPTH, RELEASE_NAME, SENTRY_DSN, TRACES_SAMPLE_RATE } from './constants';
import SentryClient from './instance';

import config from 'config';

export default new SentryClient({
    sentryDSN: SENTRY_DSN,
    tracesSampleRate: TRACES_SAMPLE_RATE,
    env: config.ENV as 'stage' | 'prod' | 'development',
    ignoreErrors: IGNORE_ERRORS_LIST,
    denyUrls: DENY_URLS,
    normalizeDepth: NORMALIZE_DEPTH,
    release: RELEASE_NAME,
});
